import * as React from 'react';
import IconProps from '@shared/icons/types/IconProps';

function SvgHiArrowNarrowRight({ size, color, ...props }: IconProps): React.JSX.Element {
	const finalSize = size !== undefined ? size : 16;
	const finalColor = color !== undefined ? color : 'currentColor';
	return (
		<svg
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width={finalSize}
			height={finalSize}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14.7515 6.3516C14.9765 6.12663 15.2817 6.00026 15.5999 6.00026C15.9181 6.00026 16.2233 6.12663 16.4483 6.3516L21.2483 11.1516C21.4733 11.3766 21.5996 11.6818 21.5996 12C21.5996 12.3182 21.4733 12.6234 21.2483 12.8484L16.4483 17.6484C16.222 17.867 15.9189 17.9879 15.6042 17.9852C15.2896 17.9825 14.9886 17.8563 14.7661 17.6338C14.5436 17.4113 14.4174 17.1103 14.4147 16.7957C14.412 16.481 14.5329 16.1779 14.7515 15.9516L17.5031 13.2H3.5999C3.28164 13.2 2.97642 13.0736 2.75137 12.8485C2.52633 12.6235 2.3999 12.3183 2.3999 12C2.3999 11.6817 2.52633 11.3765 2.75137 11.1515C2.97642 10.9264 3.28164 10.8 3.5999 10.8H17.5031L14.7515 8.0484C14.5265 7.82337 14.4002 7.5182 14.4002 7.2C14.4002 6.8818 14.5265 6.57663 14.7515 6.3516Z"
				fill={finalColor}
			/>
		</svg>
	);
}
export default SvgHiArrowNarrowRight;
